import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/site/Navbar";
import { Hero } from "@/site/Hero";
import { About } from "@/site/About";
import { Services } from "@/site/Services";
import { Marquee } from "@/site/Marquee";
import { Pricing } from "@/site/Pricing";
import { Booking } from "@/site/Booking";
import { Footer } from "@/site/Footer";
import { Impressum, Datenschutz } from "@/site/Legal";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <About />
      <Services />
      <Marquee />
      <Pricing />
      <Booking />
    </main>
    <Footer />
  </>
);

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -70 }); }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-black">
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
